/*
  2022-02-03
*/

import { arrayOf, number, shape } from 'prop-types'

import Review_v1 from './Review_v1'
import { ReviewsSummary_v1 } from './ReviewsSummary_v1'

export default {
  page: number,
  pageSize: number,
  totalItems: number,
  summary: shape(ReviewsSummary_v1),
  reviews: arrayOf(shape(Review_v1)),
}
